import React, { useState } from 'react';
import { Modal } from '@appkit4/react-components/modal';
import { Button } from '@appkit4/react-components/button';
import './RemoveAdminModal.scss';

interface RemoveAdminModalProps {
    visible: boolean;
    title: string;
    adminName: string;
    onCancel: () => void;
    onRemoveConfirm: () => Promise<void>;
    modalStyle?: React.CSSProperties;
    footerStyle?: React.CSSProperties;
    bodyStyle?: React.CSSProperties;
}

const RemoveAdminModal: React.FC<RemoveAdminModalProps> = ({
    visible,
    title,
    adminName,
    onCancel,
    onRemoveConfirm,
    modalStyle,
    footerStyle,
    bodyStyle,
}) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleConfirmButtonClick = async () => {
        try {
            setIsLoading(true);
            await onRemoveConfirm();
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal
            visible={visible}
            title={title}
            ariaLabel={title}
            onCancel={onCancel}
            modalStyle={modalStyle || { width: '500px' }}
            footerStyle={footerStyle}
            bodyStyle={bodyStyle}
            footer={
                <>
                    <Button kind="secondary" onClick={onCancel} disabled={isLoading}>
                        Cancel
                    </Button>
                    <Button kind="negative" onClick={handleConfirmButtonClick} disabled={isLoading}>
                        {isLoading ? 'Removing...' : 'Remove admin'}
                    </Button>
                </>
            }>
            <div className="ap-typography-body">
                Are you sure you want to remove <strong>{adminName}</strong> as an admin? This action removes admin
                privileges but keeps access to Design Draft.
            </div>
        </Modal>
    );
};

export default RemoveAdminModal;
